/**
 * 官网更新公告配置 (Website Announcement Configuration)
 * 
 * 每次网站有新内容或版本更新时，可在此配置公告信息。
 * 提示：更新 id 可以让之前点击过“关闭”的用户重新看到最新的公告。
 */

export interface AnnouncementItem {
  /** 唯一标识符。每次内容更新时建议递增或修改，以重置用户的关闭状态 */
  id: string;
  /** 标签文案，如 "What's New"、"Latest Update"、"Notice" */
  tag: string;
  /** 公告标题/主要内容 */
  title: string;
  /** 跳转链接，支持站内路由 (如 '/news/xxx') 或外部链接 (如 'https://...') */
  link: string;
  /** 链接行动号召文案，如 "Read more"、"Learn more" */
  linkText?: string;
  /** 是否启用公告条展示 */
  enabled: boolean;
}

export const currentAnnouncement: AnnouncementItem = {
  id: 'announcement-workspace-launch-risw-2026',
  tag: "What's New",
  title: 'HopeAI Unveils Its AI-Native Workspace for Drug Development at RISW 2026',
  link: '/news/hopeai-unveils-its-ai-native-workspace-for-drug-development-at-risw-2026',
  linkText: 'Read more',
  enabled: true,
};
